import { Input, inputStyles } from '@/components/Input';
import cn from 'classnames';
import React, { useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { buttonInvertedStyles } from '@/components/ui/Button';
import { DataToFill, ResultData } from './rentLimits';
import { Toggle } from '@/components/ui/Toggle';

type RentPriceInputStepProps = {
  onFinished: (data: ResultData) => void;
  initData: ResultData | null;
};

const RentPriceInputStep = ({ onFinished, initData }: RentPriceInputStepProps) => {
  const [formToFill, setFormToFill] = useState<DataToFill>({ ...initData });
  const { t } = useLanguage();

  const updateValue = (e: EventTarget & (HTMLInputElement | HTMLSelectElement)) => {
    const { name, value } = e;
    const item = Number(value);
    updateValueManual(name, isNaN(item) ? value : item);
  };

  const updateValueManual = (name: string, value: any) => {
    setFormToFill((last) => ({
      ...last,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (formToFill['numberOfPersons'] !== 'manual') {
      onFinished(formToFill as ResultData);
    }
  };

  return (
    <>
      <h1>Prüfung Mietangebot bzw. Neuanmietung</h1>
      <p>Bitte füllen Sie alle Felder aus:</p>
      <form onSubmit={onSubmit} action="#" className="flex flex-col md:grid gap-x-8">
        <div>
          <label className="px-4 text-xs" htmlFor="numberOfPersons">
            Anzahl aller Personen im Haushalt
          </label>
          <select
            required
            name="numberOfPersons"
            id="numberOfPersons"
            className={cn(inputStyles, 'bg-white')}
            onChange={({ target }) => updateValue(target)}
            onBlur={({ target }) => updateValue(target)}
            value={formToFill.numberOfPersons}
          >
            <option value="">{t.contactForm.concerns.default}</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="manual">7+</option>
          </select>
        </div>

        <div>
          <label htmlFor="rentPriceCold" className="px-4 text-xs">
            Nettokaltmiete in €
          </label>
          <Input
            required
            onChange={({ target }) => updateValue(target)}
            id="rentPriceCold"
            name="rentPriceCold"
            placeholder="z.B. 350"
            type="number"
            title=""
            min={1}
            value={formToFill.rentPriceCold}
          />
        </div>
        <span className="col-span-2 mb-2 text-red-600">
          {formToFill['numberOfPersons'] === 'manual' &&
            'Für Bedarfsgemeinschaften ab 7 Personen wird eine Einzelfallentscheidung zur Angemessenheit getroffen.'}
        </span>
        <div className="md:col-span-2">
          <label htmlFor="heatCosts" className="px-4 text-xs">
            Nebenkosten ohne Heizkosten in €
          </label>
          <Input
            required
            onChange={({ target }) => updateValue(target)}
            id="sideCosts"
            name="sideCosts"
            placeholder="z.B. 133"
            type="number"
            title=""
            min={0}
            value={formToFill.sideCosts}
          />
        </div>
        <Toggle
          label={'Ist die Wohnung energetisch saniert?'}
          name="isEnergeticallyRenovated"
          className="flex items-center justify-between md:text-xl lg:text-base md:col-span-2"
          onChange={(value) => updateValueManual('isEnergeticallyRenovated', value)}
          defaultValue={formToFill.isEnergeticallyRenovated}
        />
        <Toggle
          label={'Ist die Wohnung barrierefrei?'}
          name="isBarrierFree"
          className="flex items-center justify-between md:text-xl lg:text-base md:col-span-2"
          onChange={(value) => updateValueManual('isBarrierFree', value)}
          defaultValue={formToFill.isBarrierFree}
        />

        <button type="submit" className={cn(buttonInvertedStyles, 'font-bold mt-4 md:col-span-2')}>
          Mietangebot prüfen
        </button>
      </form>
    </>
  );
};

export default RentPriceInputStep;
